/**
 * Экранирование данных для HTML, собранного строкой в обход Angular-санитайзера
 * (попапы, тултипы и `DivIcon` Leaflet, tooltip-ы echarts): строка уходит в `innerHTML`.
 * Подходит и для текста, и для значения атрибута в кавычках.
 */
export const escapeHtml = (value: unknown): string =>
  String(value ?? '')
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;')
    .replace(/"/g, '&quot;')
    .replace(/'/g, '&#39;');

const NUMBER = String.raw`\s*-?(?:\d+\.?\d*|\.\d+)(?:%|deg)?\s*`;
const COLOR_FUNCTION_ARGS = String.raw`${NUMBER}(?:[,\s/]${NUMBER}){2,3}`;

const CSS_COLOR_PATTERNS: readonly RegExp[] = [
  /^#(?:[\da-f]{3,4}|[\da-f]{6}|[\da-f]{8})$/i,
  new RegExp(String.raw`^(?:rgb|hsl)a?\(${COLOR_FUNCTION_ARGS}\)$`, 'i'),
  /^[a-z]+$/i,
];

/**
 * Цвет для подстановки в атрибут `style` HTML-строки: пропускает только hex, `rgb[a]()`,
 * `hsl[a]()` с числовыми аргументами и имена цветов, иначе возвращает `fallback`.
 * Значение вида `red;background:url(…)` или с кавычкой из атрибута не выйдет.
 */
export const safeCssColor = (value: unknown, fallback: string): string => {
  if (typeof value !== 'string') return fallback;
  const color = value.trim();
  return CSS_COLOR_PATTERNS.some((pattern) => pattern.test(color)) ? color : fallback;
};

/** Число для подстановки в HTML/CSS-строку: всё, что не конечное число, заменяется на `fallback`. */
export const safeNumber = (value: unknown, fallback: number): number => {
  const number = Number(value);
  return value !== null && value !== '' && Number.isFinite(number) ? number : fallback;
};
